import React from 'react';

export function CountColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `text-right`;
  };
  return <div className={getLabelCssClasses()}>{cellContent}</div>;
}
